import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const notificationApiService = createApi({
  reducerPath: "notificationApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getCourseNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/course/status${query}`,
          method: "GET",
        };
      },
    }),
    getCourseExpiryNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/course/expiry${query}`,
          method: "GET",
        };
      },
    }),
    getTemplateUpdateNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/template-updates${query}`,
          method: "GET",
        };
      },
    }),
    getPendingTemplateUpdateNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/pending/template${query}`,
          method: "GET",
        };
      },
    }),
    updateNotificationStatus: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `notification/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetCourseNotificationsQuery,
  useGetCourseExpiryNotificationsQuery,
  useGetTemplateUpdateNotificationsQuery,
  useGetPendingTemplateUpdateNotificationsQuery,
  useUpdateNotificationStatusMutation,
} = notificationApiService;
